import React from 'react';
import { Img } from 'react-image';
import UserProfile from 'src/components/profile/UserProfile';

interface Props {
	handler: string;
	showBannerBg?: boolean;
	matchPercentage?: number;
	hasShownInterest?: boolean;
}

const CandidateProfile = ({ handler, matchPercentage, hasShownInterest, showBannerBg }: Props) => {
	return (
		<div className="md:py-4">
			{handler ? (
				<div>
					<UserProfile
						forceMobileView={true}
						userHandler={handler}
						matchPercentage={matchPercentage}
						hasShownInterest={hasShownInterest}
						showBannerBg={showBannerBg}
					/>
				</div>
			) : (
				<div className="flex flex-col items-center justify-center h-[60dvh]">
					<div className="px-8">
						<div className="flex justify-center">
							<Img
								loading="lazy"
								src="/assets/noApplicationsEmptyState.svg"
								alt="noApplicationsEmptyState"
								width="160"
								height="160"
							/>
						</div>

						<div className="text-center mt-4 text-base font-medium text-[#28293D]">No profile available!</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default CandidateProfile;
